export default __webpack_public_path__ + "static/Site-Map-aff061b6d83952ac95703aeed75e242d.png";